// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainLayout_logoutText__PTSzA {
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  margin-left: 5px;
  color: white;
}

.MainLayout_logoutIcon__8gEVY {
  fill: white;
  stroke: white;
}

.MainLayout_active__YjDem {
  border-radius: 4px;
  background: #0030CC;
  color: #fff !important;
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 0;
}

.MainLayout_collapsBtn__gtZ81 {
  position: absolute;
  top: 65px;
  right: -25px;
  background: #0030CC;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 4px;
  display: flex;
  width: 50px;
  height: 30px;
  padding: 5px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  z-index: 99;
  cursor: pointer;

  @media (min-width: 768px) {
    top: 30px;
    width: 24px;
    height: 24px;
    right: -12px;
  }
}

.MainLayout_right__m6FYS {
  padding-left: 25px !important;

  @media (min-width: 768px) {
    padding-left: 5px !important;
  }
}

.MainLayout_left__0-DeV {
  padding-right: 25px !important;

  @media (min-width: 768px) {
    padding-right: 5px !important;
  }
}

.MainLayout_hiddenText__h7BXL {
  opacity: 0 !important;
  transition: ease-in-out 0s !important;
}

.MainLayout_text__C84F\\+ {
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  opacity: 1;
  min-width: 150px;
  transition: ease-in-out 0.1s;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
}

.MainLayout_nav__6IV7i {
  display: flex;
  flex-direction: column;
  padding: 0 40px;
}

.MainLayout_item__NssJq {
  padding: 16px 20px;
  color: #737373;
  display: flex;
  align-items: center;
  gap: 10px;

  &:hover {
    color: #737373;
    transition: color 0s !important;
  }
}

.MainLayout_logoContainer__KUxEE {
  display: flex;
  justify-content: center;
  padding: 11px 0;
  background-color: black;
}

.MainLayout_activeIcon__io\\+Rj {
  path {
    stroke: #ffffff;
    fill: #ffffff;
  }
}

.ibox-holder {
  background-color: #fff;
  padding: 14px 24px;
}

.ibox-holder.dark {
  background-color: #D9D8D8;
  padding: 20px 24px;
}

.ant-table-cell-row-hover {
  background: rgba(0, 122, 255, 0.15) !important;
}

.ant-table-column-title,
th.ant-table-cell {
  font-weight: 500;
}

.ant-radio-button-wrapper {
  font-size: 16px;
  height: 40px;
  line-height: 38px;
}

.ant-radio-button-wrapper:first-child {
  border-radius: 2px 0 0 2px;
}

.ant-radio-button-wrapper:last-child {
  border-radius: 0 0 2px 2px;
}

.ant-radio-button-wrapper.ant-radio-button-wrapper-checked {
  background-color: rgba(24, 144, 255, 1);
  color: #fff;
}

.ant-radio-button-wrapper.ant-radio-button-wrapper-checked:hover {
  color: #fff;
}

.ant-btn {
  border-radius: 2px;
}

.select-search {
  border-radius: 2px;
}

.select-search > .ant-select-selector,
.ant-select-single .ant-select-selector {
  border-radius: 2px;
  min-height: 32px !important;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/MainLayout/MainLayout.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,eAAe;;EAEf;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE,6BAA6B;;EAE7B;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,8BAA8B;;EAE9B;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET;IACE,cAAc;IACd,+BAA+B;EACjC;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB","sourcesContent":[".logoutText {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n  letter-spacing: 0em;\n  margin-left: 5px;\n  color: white;\n}\n\n.logoutIcon {\n  fill: white;\n  stroke: white;\n}\n\n.active {\n  border-radius: 4px;\n  background: #0030CC;\n  color: #fff !important;\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  gap: 0;\n}\n\n.collapsBtn {\n  position: absolute;\n  top: 65px;\n  right: -25px;\n  background: #0030CC;\n  color: #fff;\n  border: 1px solid #fff;\n  border-radius: 4px;\n  display: flex;\n  width: 50px;\n  height: 30px;\n  padding: 5px;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  z-index: 99;\n  cursor: pointer;\n\n  @media (min-width: 768px) {\n    top: 30px;\n    width: 24px;\n    height: 24px;\n    right: -12px;\n  }\n}\n\n.right {\n  padding-left: 25px !important;\n\n  @media (min-width: 768px) {\n    padding-left: 5px !important;\n  }\n}\n\n.left {\n  padding-right: 25px !important;\n\n  @media (min-width: 768px) {\n    padding-right: 5px !important;\n  }\n}\n\n.hiddenText {\n  opacity: 0 !important;\n  transition: ease-in-out 0s !important;\n}\n\n.text {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow: hidden;\n  opacity: 1;\n  min-width: 150px;\n  transition: ease-in-out 0.1s;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: 0em;\n}\n\n.nav {\n  display: flex;\n  flex-direction: column;\n  padding: 0 40px;\n}\n\n.item {\n  padding: 16px 20px;\n  color: #737373;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  &:hover {\n    color: #737373;\n    transition: color 0s !important;\n  }\n}\n\n.logoContainer {\n  display: flex;\n  justify-content: center;\n  padding: 11px 0;\n  background-color: black;\n}\n\n.activeIcon {\n  path {\n    stroke: #ffffff;\n    fill: #ffffff;\n  }\n}\n\n:global(.ibox-holder) {\n  background-color: #fff;\n  padding: 14px 24px;\n}\n\n:global(.ibox-holder.dark) {\n  background-color: #D9D8D8;\n  padding: 20px 24px;\n}\n\n:global(.ant-table-cell-row-hover) {\n  background: rgba(0, 122, 255, 0.15) !important;\n}\n\n:global(.ant-table-column-title),\n:global(th.ant-table-cell) {\n  font-weight: 500;\n}\n\n:global(.ant-radio-button-wrapper) {\n  font-size: 16px;\n  height: 40px;\n  line-height: 38px;\n}\n\n:global(.ant-radio-button-wrapper:first-child) {\n  border-radius: 2px 0 0 2px;\n}\n\n:global(.ant-radio-button-wrapper:last-child) {\n  border-radius: 0 0 2px 2px;\n}\n\n:global(.ant-radio-button-wrapper.ant-radio-button-wrapper-checked) {\n  background-color: rgba(24, 144, 255, 1);\n  color: #fff;\n}\n\n:global(.ant-radio-button-wrapper.ant-radio-button-wrapper-checked:hover) {\n  color: #fff;\n}\n\n:global(.ant-btn) {\n  border-radius: 2px;\n}\n\n:global(.select-search) {\n  border-radius: 2px;\n}\n\n:global(.select-search > .ant-select-selector),\n:global(.ant-select-single .ant-select-selector) {\n  border-radius: 2px;\n  min-height: 32px !important;\n  text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoutText": `MainLayout_logoutText__PTSzA`,
	"logoutIcon": `MainLayout_logoutIcon__8gEVY`,
	"active": `MainLayout_active__YjDem`,
	"collapsBtn": `MainLayout_collapsBtn__gtZ81`,
	"right": `MainLayout_right__m6FYS`,
	"left": `MainLayout_left__0-DeV`,
	"hiddenText": `MainLayout_hiddenText__h7BXL`,
	"text": `MainLayout_text__C84F+`,
	"nav": `MainLayout_nav__6IV7i`,
	"item": `MainLayout_item__NssJq`,
	"logoContainer": `MainLayout_logoContainer__KUxEE`,
	"activeIcon": `MainLayout_activeIcon__io+Rj`
};
export default ___CSS_LOADER_EXPORT___;
